// Central content model for South East Collectibles — both brand arms.

export const SOCIALS = {
  studios: "@secstudios",
  collectibles: "@south_east_collectibles",
  location: "Eastbourne, South East England",
};

const BASE =
  "https://customer-assets-jai6qajn.emergentagent.net/job_se-collectibles/artifacts";

export const IMAGES = {
  heroCards: `${BASE}/1a87n6fz_bellingham%20psa%209.jpg`,
  mic:
    "https://images.unsplash.com/photo-1531651008558-ed1740375b39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxicm9hZGNhc3QlMjBzdHVkaW8lMjBtaWNyb3Bob25lJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4NDkwMjY2OHww&ixlib=rb-4.1.0&q=85",
  // Real card photos used for design across the site
  cardBellingham: `${BASE}/1a87n6fz_bellingham%20psa%209.jpg`,
  cardMessi: `${BASE}/y13yw5l9_messi%201-1%20topps%20chorme.jpg`,
  cardYamalWonderkids: `${BASE}/c1tzx0pi_wonderkids%20yamal%2010.webp`,
  cardYamalOrange: `${BASE}/e25t8n3o_lamine%20yamal%20case%20hit.jpg`,
  cardEndrick: `${BASE}/8tkso6dr_psa%2010%20ewndriuck.jpg`,
  cardTripleAuto: `${BASE}/p4e4qtyb_triple%20auto%20uccc%20chrome.jpg`,
};

export const SERVICES = [
  // ---------------- SEC STUDIOS ----------------
  {
    slug: "studio-rental",
    brand: "studios",
    brandLabel: "SEC Studios",
    number: "01",
    category: "Studio Hire",
    title: "Studio Space Rental & Lockouts",
    tagline:
      "Two Professional Setups. 100% Unbranded Backgrounds. Your Brand Front & Center.",
    intro:
      "A clean, professional canvas built entirely around YOUR brand. Zero studio logos, signs, or watermarks on camera — just broadcast-grade infrastructure.",
    cta: "Book Your Slot",
    image:
      "https://images.unsplash.com/photo-1615821430614-3d7d2685e2f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxicm9hZGNhc3QlMjBzdHVkaW8lMjBtaWNyb3Bob25lJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4NDkwMjY2OHww&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-7",
    priceLabel: "Commission-based",
    tiers: [
      {
        name: "Standard Studio Hire (Hourly)",
        price: "By Commission",
        desc: "Access to your choice of one professional setup, booked by the hour with a 2-hour minimum.",
      },
      {
        name: "Half-Day Lockout (4 Hours)",
        price: "By Commission",
        desc: "Ideal for multi-episode podcast batching or major breaking collabs.",
      },
      {
        name: "Full-Day Lockout (8 Hours)",
        price: "By Commission",
        desc: "Complete studio exclusivity for day-long events, tournaments, or media productions.",
        highlight: true,
      },
    ],
    features: [
      {
        title: "The Breaking Desk",
        desc: "Neutral high-grip playmats, overhead HD camera rigging, customizable RGB backdrop lighting, and modular display shelving.",
      },
      {
        title: "The Creator Lounge",
        desc: "Wide-angle collaborative stage, comfortable seating, broadcast-grade dual microphones, and acoustic treatment.",
      },
      {
        title: "High-Speed Fiber Internet",
        desc: "Dedicated hardwired ethernet lines optimized for zero-drop Whatnot and Twitch live streaming.",
      },
      {
        title: "On-Site Staff Support",
        desc: "Quick assistance with lighting calibration and audio leveling at the start of every session.",
      },
    ],
  },
  {
    slug: "streamer-tech",
    brand: "studios",
    brandLabel: "SEC Studios",
    number: "02",
    category: "Tech & Setup",
    title: "Streamer Tech & OBS Setup",
    tagline: "Eliminate Technical Headaches. Stream with Broadcast Quality.",
    intro:
      "Don't let poor audio, blurry cameras, or laggy overlays hurt your sales. Our technical experts configure your hardware and software so you can focus 100% on entertaining and selling.",
    cta: "Upgrade Your Stream",
    image:
      "https://images.pexels.com/photos/33888375/pexels-photo-33888375.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-5",
    tiers: [
      {
        name: "Remote Tech & OBS Consultation",
        price: "£50",
        desc: "1-hour intensive virtual session. We remote in to configure scene routing, audio filters, bitrates, and camera resolution.",
      },
      {
        name: "In-Studio Stream Optimization",
        price: "£135",
        desc: "Full on-site hardware and software overhaul: multi-camera rigging, LED calibration, mic acoustics, and a live test broadcast.",
        highlight: true,
      },
    ],
    features: [
      {
        title: "Audio Mastery",
        desc: "Crystal-clear microphone setup with background noise suppression — no more echoing rooms or clipping during loud pulls.",
      },
      {
        title: "Multi-Cam Routing",
        desc: "Seamless switching between face cam, macro card-table view, and digital screen captures with hotkey integration.",
      },
      {
        title: "Platform Ready",
        desc: "Compatible with OBS Studio, Streamlabs, Whatnot Studio & Twitch. Post-setup support sheet included.",
      },
    ],
  },
  {
    slug: "custom-branding",
    brand: "studios",
    brandLabel: "SEC Studios",
    number: "03",
    category: "Design Agency",
    title: "Custom Streamer Branding",
    tagline: "Stand Out in the Feed with Premium High-Contrast Graphics.",
    intro:
      "On fast-paced live platforms like Whatnot and Twitch, your visual identity is your reputation. We design sleek, memorable branding engineered to look sharp on mobile screens and stream overlays.",
    cta: "Claim Your Brand",
    image:
      "https://images.pexels.com/photos/9794458/pexels-photo-9794458.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-5",
    tiers: [
      {
        name: "Logo & Brand Identity Pack",
        price: "£95",
        desc: "Custom monogram/logo, typography hierarchy, brand color palette, and high-res transparent PNGs / vector files.",
      },
      {
        name: "Stream Overlay & Graphics Pack",
        price: "£75",
        desc: "Custom camera borders, 'Be Right Back' & 'Starting Soon' screens, lower-third social popups, and profile banners.",
      },
      {
        name: "Complete Streamer Branding Suite",
        price: "£160",
        desc: "The ultimate visual launch. Includes both the Logo Pack and full Overlay Pack. Save £10.",
        highlight: true,
      },
    ],
    features: [
      {
        title: "Designed for Whatnot & OBS",
        desc: "Formatted to exact pixel dimensions so your camera feeds never get obscured by UI elements.",
      },
      {
        title: "Fast 5-Day Turnaround",
        desc: "Includes up to 2 rounds of creative revisions to ensure your brand hits the exact vibe you picture.",
      },
      {
        title: "Broadcast-Ready Files",
        desc: "Delivered in PNG, WEBP, and vector formats. Portfolio available on Instagram.",
      },
    ],
  },
  {
    slug: "streamer-incubator",
    brand: "studios",
    brandLabel: "SEC Studios",
    number: "04",
    category: "VIP Flagship Bundle",
    title: "The Streamer Incubator",
    tagline: "From Zero to Broadcast-Ready: The Turnkey Hobby Launchpad.",
    intro:
      "Ready to launch your sports card or collectibles brand on Whatnot but don't know where to start? We combine our design agency, technical consulting, and physical studio into one powerhouse launch package.",
    cta: "Apply For Launch",
    image:
      "https://images.unsplash.com/photo-1616588589676-62b3bd4ff6d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxzdHJlYW1lciUyMHNldHVwJTIwcmdiJTIwbGVkJTIwbmVvbnxlbnwwfHx8fDE3ODQ5MDI2Njh8MA&ixlib=rb-4.1.0&q=85",
    span: "lg:col-span-12",
    priceHeadline: "£295",
    priceSub: "Total bundle launch price — an all-in-one saving of £100. Value: £395.",
    tiers: [
      {
        name: "Complete Streamer Branding Suite",
        price: "£160",
        desc: "Custom logo, typography, color palette, stream camera overlays, BRB screens, and social banners.",
      },
      {
        name: "In-Studio Tech & OBS Optimization",
        price: "£135",
        desc: "Full hardware configuration, multi-camera routing, microphone leveling, and lighting calibration.",
      },
      {
        name: "2-Hour Studio Debut Broadcast Credit",
        price: "£100",
        desc: "Host your inaugural live show from our 100% unbranded breaking desk or creator lounge with on-site support.",
      },
    ],
    features: [
      {
        title: "Cross-Promotion Bonus",
        desc: "We shout out your debut stream on our @south_east_collectibles channels to jumpstart your initial audience.",
      },
      {
        title: "Limited Availability",
        desc: "Limited to 4 Incubator launches per month to ensure quality and dedicated attention.",
      },
    ],
  },
  // ---------------- SOUTH EAST COLLECTIBLES ----------------
  {
    slug: "card-prep",
    brand: "collectibles",
    brandLabel: "South East Collectibles",
    number: "05",
    category: "Card Cleaning & Prep",
    title: "Professional Card Prep",
    tagline: "Maximize Your Graded Gems. We Recommend Cleaning Before Grading.",
    intro:
      "Every card is inspected under high-power magnification to identify surface wax, oils, print dust, and edge micro-debris — then treated with safe, non-invasive detailing.",
    cta: "Prep Your Grails",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_se-collectibles/artifacts/e25t8n3o_lamine%20yamal%20case%20hit.jpg",
    span: "lg:col-span-6",
    tiers: [
      {
        name: "Standard Card Cleaning & Prep",
        price: "£10.00",
        desc: "Safe surface wipe, microfiber polish, fresh penny sleeve, and insertion into a brand new Card Saver I. Ideal for modern chrome & paper stock.",
      },
      {
        name: "Premium Deep Prep & Detailing",
        price: "£20.00",
        desc: "Targeted detailing for stubborn wax, residue, or high-value vintage cards before submission to PSA, BGS, or CGC.",
        highlight: true,
      },
      {
        name: "Bulk Card Prep (10+ Cards)",
        price: "50% OFF",
        desc: "Discounted volume rate for set builders, break submitters, and local dealers prepping large batches.",
      },
    ],
    features: [
      {
        title: "Magnification Inspection",
        desc: "High-power inspection identifies surface wax, oils, print dust, and edge micro-debris before treatment.",
      },
      {
        title: "Safe & Non-Invasive",
        desc: "Specialized microfiber detailing and grading-safe techniques — strictly zero alteration, trimming, or harsh chemicals.",
      },
      {
        title: "Strict Intake Logging",
        desc: "Full condition reporting on all submissions. Drop off in-studio at Eastbourne or ship via insured mail.",
      },
    ],
  },
  {
    slug: "group-grading",
    brand: "collectibles",
    brandLabel: "South East Collectibles",
    number: "06",
    category: "Group Grading",
    title: "Group Grading Submissions",
    tagline: "Your Pipeline to PSA, BGS, and CGC — Without the International Hassle.",
    intro:
      "We handle submission entry, customs documentation, insured international shipping, and safe return packaging. You pay the actual grading tier fee plus our handling markup.",
    cta: "Submit With Us",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_se-collectibles/artifacts/8tkso6dr_psa%2010%20ewndriuck.jpg",
    span: "lg:col-span-6",
    tiers: [
      {
        name: "Value Group Submission",
        price: "£10 + fee",
        desc: "We handle submission entry, customs, insured international shipping, and return packaging. Pay actual grader fee + markup.",
      },
      {
        name: "Express / Priority Submission",
        price: "£20 + fee",
        desc: "Expedited handling for high-end grail cards requiring fast turnaround. Individual tracking and priority courier transit.",
        highlight: true,
      },
    ],
    features: [
      {
        title: "100% Insured Transit",
        desc: "Your cards are fully insured from the moment they leave our office until they return securely in pristine slabs.",
      },
      {
        title: "Live Status Updates",
        desc: "Transparent email & WhatsApp alerts at every stage: Shipped, Received, Grading in Progress, and Ready for Pickup.",
      },
      {
        title: "Regular Departures",
        desc: "Next group submission departs on the 1st and 15th of each month. Secure pickup at our Eastbourne studio office.",
      },
    ],
  },
  {
    slug: "consignment",
    brand: "collectibles",
    brandLabel: "South East Collectibles",
    number: "07",
    category: "High-Value Consignment",
    title: "Grail Consignment Service",
    tagline: "Maximum Liquidity. Live Stream Hype. Industry-Low Commissions.",
    intro:
      "Standard marketplaces take 10–13% in fees and leave your listing in a crowded feed. We showcase your cards on HD Whatnot broadcasts, our Instagram & eBay, and private buyer groups to get a top-dollar sale fast.",
    cta: "Consign Your Hits",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_se-collectibles/artifacts/p4e4qtyb_triple%20auto%20uccc%20chrome.jpg",
    span: "lg:col-span-12",
    tiers: [
      {
        name: "Tier 1 — £100 to £499 Value",
        price: "10%",
        desc: "Professional macro studio photography, listing prep, live broadcast promotion, and secure buyer shipping.",
      },
      {
        name: "Tier 2 — £500 to £1,499 Value",
        price: "8%",
        desc: "Featured 'Main Event Grail' placement during our highest-traffic weekly breaking streams. Dedicated social reel preview.",
      },
      {
        name: "Tier 3 — £1,500+ (Ultra-Grails)",
        price: "6%",
        desc: "VIP treatment for premier assets. Direct outreach to our private collector network and prime auction spotlight.",
        highlight: true,
      },
    ],
    features: [
      {
        title: "The 'Grade to Consign' VIP Pipeline",
        desc: "Bring us a raw high-value card: FREE Premium Card Prep (£20 value) and WAIVED £10 admin fee when you consign at 7% commission.",
      },
      {
        title: "Fast, Guaranteed Payouts",
        desc: "Simple 1-page consignment agreement with fast payouts. Vault storage and full insurance while in our possession.",
      },
    ],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
export const studiosServices = SERVICES.filter((s) => s.brand === "studios");
export const collectiblesServices = SERVICES.filter((s) => s.brand === "collectibles");
